import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Model } from "survey-core";
import { useParams } from "react-router-dom";

import {
  BodyTable,
  HeaderItem,
  IconContainer,
  IconFaRegEye,
  IconName,
  LabelHeader,
  NotesMainGrid,
  NotesViewPanel,
  NoteViewGrid,
  OuterBodyGrid,
  TableWidth,
} from "../styles/TabsStyle";
import fontWeight from "../../../styles/mui/fontWeight";
import others from "../../../styles/colors/others";
import { NoteHeaderLabel } from "../../../constants/Authorization";
import colors from "../../../styles/colors/colors";
import NotesPreview from "./NotePreview";
import { NotesList, NotesView } from "../../../models/AuthorizationDetailsTab";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import { decryptId } from "../../../utils";
export interface PropsFromState {
  title?: string;
  notesListState: NotesList[];
  notesViewState: NotesView;
}

export interface PropsFromDispatch {
  getNotesList: (referralId: number) => void;
  getNotesView: (referralNoteId: number) => void;
  getNotesViewByDisciplineNoteId: (disciplineNoteId: number) => void;
}
type AllProps = PropsFromState & PropsFromDispatch;

const Notes: React.FC<AllProps> = ({
  title,
  notesListState,
  getNotesList,
  getNotesViewByDisciplineNoteId,
  getNotesView,
  notesViewState,
}) => {
  const [selectedSurvey, setSelectedSurvey] = React.useState<Model | null>(
    null
  );
  const [notesList, setNotesList] = React.useState<NotesList[]>([]);
  const { authNo } = useParams();
  const [referralId, setReferralId] = React.useState<number | null>(null);
  const hasUserClickedView = React.useRef(false);

  useEffect(() => {
    const loadReferralId = async () => {
      if (!authNo) {
        setReferralId(null);
        return;
      }

      const decryptedId = await decryptId(authNo);
      const parsed = Number(decryptedId);
      setReferralId(Number.isFinite(parsed) ? parsed : null);
    };

    void loadReferralId().catch(() => setReferralId(null));
  }, [authNo]);

  useEffect(() => {
    if (referralId !== null) {
      getNotesList(referralId);
    }
  }, [referralId]);

  useEffect(() => {
    if (notesListState) {
      setNotesList(notesListState);
    }
  }, [notesListState]);

  const renderHeaderCell = (label: string) => (
    <Typography
      variant="body1"
      fontWeight={fontWeight.Weight[5]}
      color={colors.black[14]}
    >
      {label}
    </Typography>
  );

 const handleViewNote = (referralNoteId: number, disciplineNoteId: number) => {
  hasUserClickedView.current = true;
   if (disciplineNoteId > 0) {
     getNotesViewByDisciplineNoteId(disciplineNoteId);
   } else if (referralNoteId > 0) {
     getNotesView(referralNoteId);
   }
 };

 useEffect(() => {
    if (notesViewState.noteEntryJson && hasUserClickedView.current) {
      const parsedJson = JSON.parse(notesViewState.noteEntryJson);

      const survey = new Model({
        pages: parsedJson.pages,
      });

      survey.data = parsedJson;
      setSelectedSurvey(survey);
    }
  }, [notesViewState]);

  useEffect(() => {
    return () => {
      hasUserClickedView.current = false;
      setSelectedSurvey(null);
    };
  }, []);

  return (
    <Grid container sx={OuterBodyGrid}>
      <Grid size={12} sx={NotesMainGrid}>
        <Grid size={6} sx={{ display: "flex", flexDirection: "column" }}>
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={fontWeight.Weight[3]}
              color={others.otherColors[45]}
              sx={LabelHeader}
            >
              Member Verbal Notification, Referral Notification, Phone, Fax,
              Email Request For Information
            </Typography>
          </Box>
          <Grid container pt={"1rem"}>
            <Grid size={12} pl={"1rem"}>
              <TableContainer sx={TableWidth}>
                <Table sx={BodyTable}>
                  <TableHead sx={HeaderItem}>
                    <TableRow>
                      {NoteHeaderLabel.map((col) => (
                        <TableCell key={col.label} width={col.width}>
                          {renderHeaderCell(col.label)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {notesList.length > 0 ? (
                      notesList.map((row) => (
                        <TableRow key={row.communicationType}>
                          <TableCell>{formatDate(row.dateCreated, DateFormats.MM_DD_YYYY)}</TableCell>
                          <TableCell>{row.communicationType}</TableCell>
                          <TableCell align="center">
                            <Box sx={IconContainer}>
                              <IconFaRegEye
                                onClick={() =>
                                  handleViewNote(row.referralNoteId,row.disciplineNoteId)
                                }
                              />
                              <Box sx={IconName} className="tooltip">
                                View
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell align="center" colSpan={3}>
                          No records found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={6} sx={NoteViewGrid}>
          <Box sx={NotesViewPanel}>
            {selectedSurvey ? (
              <NotesPreview model={selectedSurvey} title={title} />
            ) : (
              <Typography
                color={colors.black[14]}
                variant="body1"
                fontWeight={fontWeight.Weight[5]}
              >
                View Note Here
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Notes;
